const API_BASE = import.meta.env.VITE_API_URL ?? '/api';

/** Incorrect verification codes must not trigger the normal API sign-out handler. */
export async function verificationApi<T>(path: string, body?: unknown, admin = false): Promise<T> {
  const token = localStorage.getItem(admin ? 'tt_admin_token' : 'tt_token');
  const response = await fetch(`${API_BASE}/auth/2fa/${path}`, {
    method: body === undefined ? 'GET' : 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(admin ? { 'X-Auth-Audience': 'admin' } : {}) },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(Array.isArray(data.message) ? data.message.join(', ') : data.message || 'Could not verify. Please try again.');
  return data;
}
